import { pageCard } from "#build/ui";

export default defineAppConfig({
  // https://ui.nuxt.com/getting-started/theme#design-system

  ui: {
    colors: {
      primary: "blue",
      neutral: "slate",
    },
    pageCard: {
      variants: {
        reverse: {
          true: {
            wrapper: "order-last",
          },
        },
        variant: {
          outline: {
            // root: "bg-linear-to-t from-neutral-200/30 to-neutral-50/30",
          },
        },
      },
    },
  },
});
